export const GET_EMERGENCY_CONTANCT = 'GET_EMERGENCY_CONTANCT';
export const LOADING_EMERGENCY_CONTANCT = 'LOADING_EMERGENCY_CONTANCT';
export const SAVE_LOADER_EMERGENCY_CONTACT = 'SAVE_LOADER_EMERGENCY_CONTACT';